export enum LazyLibId {
  html2canvas = 'HTML2CANVAS',
  jspdf = 'JSPDF',
  xlsx = 'XLSX',
  googleMaps = 'GOOGLE_MAPS',
  googleMapsClusterer = 'GOOGLE_MAPS_CLUSTERER',
  zenDesk = 'ze-snippet', // note zendesk won't work if this id changed
  Paytabs = 'paytabs',
  tableau = 'tableau-viz',
}
